<template>
  <div>
    <nav-bar></nav-bar>
    <div class="container">
      <div class="section">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul v-if="client">
            <li><a @click="$router.push('/training', $router.go())">Entrenamiento</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{ clientName }}</a></li>
          </ul>
          <ul v-else>
            <li class="is-active"><a href="#" aria-current="page">Entrenamiento</a></li>
          </ul>
        </nav>
        <div class="training-filter">
          <div class="field">
            <label class="label">Tipo</label>
            <div class="control">
              <div class="select">
                <select v-model="typeTraining" @change="getTraining">
                  <option v-for="type in types" :key="type.idTypeTrainning" :value="type.idTypeTrainning">
                    {{ type.typeTrainning }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">Revisado</label>
            <div class="control">
              <div class="select">
                <select v-model.number="revised">
                  <option value=-1>Todos</option>
                  <option value=0>No</option>
                  <option value=1>Si</option>
                </select>
              </div>
            </div>
          </div>

          <div class="button is-primary is-left" @click="getTraining">
            <span class="icon"><i class="fas fa-sync-alt"></i></span>
            <span class="is-capitalized">Actualizar</span>
          </div>
        </div>
        <br><br>

        <!-- input  -->
        <div class="control is-expanded">
          <input class="input" type="text" placeholder="Buscar Mensaje (Esc para cancelar)" v-model="textFilter"
            v-on:keyup.esc="textFilter = null">
        </div>

        <br><br>
        <div class="container" style="overflow: scroll">
          <table class="table is-striped is-fullwidth">

            <thead>
              <tr>
                <th class="is-capitalized">Tipo</th>
                <th class="is-capitalized">Chatbot</th>
                <th class="is-capitalized">Nombre</th>
                <th class="is-capitalized">Intención</th>
                <th class="is-capitalized">Frase</th>
                <th class="is-capitalized">Mensaje</th>
                <th class="is-capitalized has-text-centered">Revisado</th>
                <th class="is-capitalized">Fecha</th>
                <th class="table-button-column"></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="training in filteredTrainings" v-if="revised === -1 || training.revised === revised"
                :key="training.idTrainning">
                <td>{{ training.typeName }}</td>
                <td>{{ training.client }}</td>
                <td>{{ training.userName }}</td>
                <td>{{ training.intent }}</td>
                <td>{{ training.term }}</td>
                <td style="max-width: 150px">{{ training.message }}</td>
                <td class="has-text-centered">
                  <span v-if="training.revised === 1" class="icon has-text-success">
                    <i class="fas fa-check"></i>
                  </span>
                  <span v-if="training.revised === 2" class="icon has-text-danger">
                    <i class="fas fa-times"></i>
                  </span>
                </td>
                <td>{{ training.date }}</td>
                <td>
                  <div class="field has-addons">
                    <p class="control">
                      <a @click="addKeywords(training)" class="button is-warning" title="Añadir Keywords">
                        <span class="icon"><i class="fas fa-edit"></i></span>
                      </a>
                    </p>
                    <p class="control">
                      <a @click="checkClient(training)" class="button is-primary" title="Revisar">
                        <span class="icon"><i class="fas fa-search"></i></span>
                      </a>
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>

          </table>
        </div>

        <nav v-if="!textFilter" class="pagination is-centered" role="navigation" aria-label="pagination">
          <a class="pagination-previous" @click="previousPage" :disabled="paginator.current === 0">Anterior</a>
          <a class="pagination-next" @click="nextPage" :disabled="paginator.current >= paginator.total">Siguiente</a>
          <ul class="pagination-list">
            <li v-for="page in paginator.total + 1" :key="page">
              <a :class="page - 1 === paginator.current ? 'pagination-link is-current' : 'pagination-link'"
                @click="goPage(page - 1)">
                {{ page }}
              </a>
            </li>
          </ul>
        </nav>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      textFilter: null,
      typeTraining: 0,
      revised: -1,
      types: {},
      trainings: [],
      paginatedTrainings: [],
      page: 0,
      paginator: {
        current: 0,
        total: 0,
        limit: 100
      }
    }
  },
  watch: {
    revised: function () {
      this.paginator.current = 0
      this.paginate()
    }
  },
  created() {
    this.getTypes()
    this.getTraining()
    this.breadcrumbDetails()
  },
  computed: {
    filteredTrainings() {
      let self = this

      if (!self.textFilter) {
        return this.paginatedTrainings
      }

      return this.trainings.filter(function (training) {
        if ((training.message.search(self.textFilter) > -1) || (training.message.toLowerCase().search(self.textFilter) > -1)) {
          return true
        }
      })
    }
  },
  methods: {
    breadcrumbDetails() {
      if (this.client) {
        this.api.post('/ClientById/', { idClient: this.client }).then(response => {
          this.clientName = response.client.name
        })
      }
    },
    getTraining() {
      this.api.post('/TrainningGetList', { type: this.typeTraining, idClient: this.client }).then(response => {
        this.trainings = response.trainnings
        this.paginator.current = 0
        this.paginate()
      })
    },
    getTypes() {
      this.api.post('/DataTypeTrainningList').then(response => {
        this.types = response.typesTrainning
        this.typeTraining = response.typesTrainning[0].idTypeTrainning
      })
    },
    addKeywords(training) {
      this.$router.push('/clients/' + training.idClient + '/training/' + training.idTrainning + '/keywords/' + training.idDictionary)
    },
    checkClient(training) {
      const message = '¿Desea indicar que ha revisado la frase?'
      const okText = 'Revisar'
      const koText = 'Descartar'
      const koStyle = 'is-danger'
      const params = { idTrainning: training.idTrainning }

      this.dialog.confirm({ message, okText, koText, koStyle }).then(() => {
        this.api.post('/TrainningRevised', params).then(() => {
          this.trainings = this.trainings.map(training => ({
            ...training,
            revised: training.idTrainning === params.idTrainning ? 1 : training.revised
          }))
          this.paginate()
        })
      }).catch(() => {
        this.api.post('/TrainningDiscard', params).then(() => {
          this.trainings = this.trainings.map(training => ({
            ...training,
            revised: training.idTrainning === params.idTrainning ? 2 : training.revised
          }))
          this.paginate()
        })
      })
    },
    paginate() {
      const filter = this.revised === -1 ? this.trainings : this.trainings.filter(training => training.revised === this.revised)
      this.paginator.total = Math.floor(filter.length / this.paginator.limit)
      this.paginatedTrainings = filter.slice(
        this.paginator.current * this.paginator.limit,
        (this.paginator.current + 1) * this.paginator.limit)
    },
    nextPage() {
      if (this.paginator.current < this.paginator.total) {
        this.paginator.current++
        this.paginate()
        window.scrollTo(0, 0)
      }
    },
    previousPage() {
      if (this.paginator.current > 0) {
        this.paginator.current--
        this.paginate()
        window.scrollTo(0, 0)
      }
    },
    goPage(page) {
      this.paginator.current = page
      this.paginate()
      window.scrollTo(0, 0)
    }
  }

}
</script>

<style>
.training-filter {
  display: flex;
  align-items: flex-end;
  gap: 40px;
}
.training-filter .field {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Training/Training.vue